import Hairline from './component.styles'
export default Hairline
